import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  typeFlow: "",
  ipAddress: "",
  negotiatePage: true,
  idLoja: "",
  nomeLoja: "",
  pinPadAvailable: false,
};

export const addTypeFlowState = createAsyncThunk(
  `security/setFlowState`,
  async (typeFlow: string) => {
    return typeFlow;
  }
);

export const addPinPadAvailable = createAsyncThunk(
  `security/setPinPadAvailable`,
  async (pinPadAvailable: boolean) => {
    return pinPadAvailable;
  }
);

export const addIPAddressState = createAsyncThunk(
  `security/setIPAddressState`,
  async (ipAddress: string) => {
    return ipAddress;
  }
);

export const addNegotiatePage = createAsyncThunk(
  `security/setNegotiate`,
  async (negotiatePage: boolean) => {
    return negotiatePage;
  }
);

export const addIDLojaState = createAsyncThunk(
  `security/setIDLojaState`,
  async (idLoja: string) => {
    return idLoja;
  }
);

export const addNomeLojaState = createAsyncThunk(
  `security/setNomeLojaState`,
  async (nomeLoja: string) => {
    return nomeLoja;
  }
);

export const securitySlice = createSlice({
  name: "security",
  initialState: { ...initialState },
  reducers: {
    cleanStatesecurity: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(addTypeFlowState.fulfilled, (state, action) => {
      state.typeFlow = action.payload;
    });
    builder.addCase(addIPAddressState.fulfilled, (state, action) => {
      state.ipAddress = action.payload;
    });
    builder.addCase(addPinPadAvailable.fulfilled, (state, action) => {
      state.pinPadAvailable = action.payload;
    });
    builder.addCase(addNegotiatePage.fulfilled, (state, action) => {
      state.negotiatePage = action.payload;
    });
    builder.addCase(addIDLojaState.fulfilled, (state, action) => {
      state.idLoja = action.payload;
    });
    builder.addCase(addNomeLojaState.fulfilled, (state, action) => {
      state.nomeLoja = action.payload;
    });
  },
});

export const { cleanStatesecurity } = securitySlice.actions;
export default securitySlice.reducer;
